import Aula, { FinderAulas, RetornoAula } from 'Interface/Aulas';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'Aulas';

const url = '/aulas';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag, 'Treinamentos'],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarAulas: construtor.query<FinderAulas, Parametros | void>({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.aulas
            ? [
                ...resultado.aulas.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarAula: construtor.query<
        RetornoAula,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarAula: construtor.mutation<Aula, Partial<Aula>>({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: formData(dados, 'POST'),
        }),
        invalidatesTags: (resultado, erro, { treinamento_id }) =>
          !erro
            ? [
                { type: tag, id: 'LISTA' },
                { type: 'Treinamentos', id: treinamento_id },
              ]
            : [],
      }),
      editarAula: construtor.mutation<
        Aula,
        Partial<Aula> & Pick<Aula, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'PUT',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerAula: construtor.mutation<Aula, Partial<Aula> & Pick<Aula, 'id'>>({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'DELETE',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id, treinamento_id }) =>
          !erro
            ? [
                { type: tag, id },
                { type: 'Treinamentos', id: treinamento_id },
              ]
            : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarAulasQuery,
  useRecuperarAulaQuery,
  useAdicionarAulaMutation,
  useEditarAulaMutation,
  useRemoverAulaMutation,
} = apiExtendida;
